<style >
</style>
<template>
	<div class="mt-5">

		<v-container>
			<v-row>
				<v-col cols="12">
						<h1 class="welcome-headline">Welcome to MW X</h1>
						<p class="text-large">MW X is Meisterworks' interactive portal for participants, collaborators and clients. Please choose a login option below.</p>
		
				</v-col>
				<v-col cols="12" md="6">
					<v-card color="green" dark>
						<v-card-title class="headline font-weight-thin">I am a client</v-card-title>
						<v-card-subtitle>Login here to access Meisterworks' project and contract administration toolkit. </v-card-subtitle>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="white" outlined link href="/client">Login</v-btn>
						</v-card-actions>
					</v-card>
				</v-col>
				<v-col cols="12" md="6">
					<v-card color="primary" dark>
						<v-card-title class="headline font-weight-thin">I am a participant</v-card-title>
						<v-card-subtitle>Login here to access an existing appointment or manage your account. </v-card-subtitle>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="white" outlined link href="/participant">Login</v-btn>
						</v-card-actions>
					</v-card>
				</v-col>
<!-- 				<v-col cols="6" md="4">
					<v-card>
						<v-card-title class="headline font-weight-thin text-green">Take part in research</v-card-title>
						<v-card-subtitle style="font-size: 1em; line-height: 1.4em;">Taking part is easy! Register today in order to receive invitations to our latest studies. Unline other user research companies we don't use a points system, all of our studies offer real incentives.</v-card-subtitle>
						<v-card-actions >
							<v-spacer></v-spacer>
							<v-btn color="accent" link href="/register">Register now</v-btn>
						</v-card-actions>
					</v-card>
				</v-col>
				<v-col cols="6" sm="4"> 
					<v-card>
						<v-img src="../assets/img/research2.jpg" class="white--text align-end" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" height="180px">
							<v-card-title>Taking Part in Market Research – What to Expect: A Quick Guide</v-card-title>
						</v-img>

						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn icon  link href="/what-to-expect">
								<v-icon >mdi-link</v-icon>
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-col>
 -->
		</v-row>
	
</v-container>
</div>
</template>

<script>



 export default {
	name: 'Welcome',
}
</script>
